var map = {
	"./$pac.svg": "07eb",
	"./0xbtc.svg": "2cf9",
	"./1inch.svg": "d340",
	"./2give.svg": "8423",
	"./aave.svg": "246f",
	"./abt.svg": "72f7",
	"./act.svg": "3335",
	"./actn.svg": "dd6c",
	"./ada.svg": "8d70",
	"./add.svg": "a5f9",
	"./adx.svg": "3bd5",
	"./ae.svg": "f4d3",
	"./aeon.svg": "72da",
	"./aeur.svg": "f0de",
	"./agi.svg": "ac41",
	"./agix.svg": "48a8",
	"./agrs.svg": "750e",
	"./aion.svg": "ae51",
	"./algo.svg": "b3f0",
	"./alpha.svg": "ec6b",
	"./amb.svg": "1726",
	"./amp.svg": "2811",
	"./ampl.svg": "51e4",
	"./ant.svg": "7066",
	"./apex.svg": "e450",
	"./api3.svg": "dfb2",
	"./appc.svg": "4b10",
	"./arb.svg": "4f31",
	"./ardr.svg": "8d0b",
	"./arg.svg": "822b",
	"./ark.svg": "1f81",
	"./arn.svg": "30c7",
	"./arnx.svg": "2ec5",
	"./ary.svg": "0bb5",
	"./ast.svg": "2d54",
	"./atm.svg": "3fe2",
	"./atom.svg": "0595",
	"./audr.svg": "76a1",
	"./auto.svg": "e94d",
	"./avax.svg": "7f87",
	"./axs.svg": "105c",
	"./aywa.svg": "c8bc",
	"./bab.svg": "d924",
	"./bal.svg": "d5e2",
	"./band.svg": "cbbd",
	"./bat.svg": "0543",
	"./bay.svg": "8e64",
	"./bcbc.svg": "d04a",
	"./bcc.svg": "7eef",
	"./bcd.svg": "2897",
	"./bch.svg": "42d8",
	"./bcio.svg": "2b37",
	"./bcn.svg": "74e1",
	"./bco.svg": "7ad7",
	"./bcpt.svg": "daf4",
	"./bdl.svg": "70ed",
	"./beam.svg": "20e8",
	"./bela.svg": "bf91",
	"./bitcoin.svg": "8d04",
	"./bix.svg": "ee92",
	"./blcn.svg": "3422",
	"./blk.svg": "da37",
	"./block.svg": "d473",
	"./blz.svg": "d3e2",
	"./bnb.svg": "ce73",
	"./bnt.svg": "d199",
	"./bnty.svg": "aa20",
	"./bond.svg": "407b",
	"./booty.svg": "a36d",
	"./bos.svg": "d075",
	"./bpt.svg": "cf83",
	"./bq.svg": "62d4",
	"./brd.svg": "448a",
	"./bsd.svg": "4773",
	"./bsv.svg": "0f73",
	"./btc.svg": "d642",
	"./btcd.svg": "138d",
	"./btch.svg": "00db",
	"./btcp.svg": "785f",
	"./btcz.svg": "aefb",
	"./btdx.svg": "26c2",
	"./btg.svg": "d273",
	"./btm.svg": "d6b3",
	"./bts.svg": "c81c",
	"./btt.svg": "878e",
	"./btx.svg": "1456b",
	"./burst.svg": "7aa0",
	"./bze.svg": "5015",
	"./cad.svg": "1a88",
	"./call.svg": "561c",
	"./cc.svg": "c634",
	"./cdn.svg": "7fe8",
	"./cdt.svg": "c8f9",
	"./celo.svg": "6fc5f",
	"./cenz.svg": "d5ed",
	"./chain.svg": "b2b6",
	"./chat.svg": "2490",
	"./chips.svg": "19f8",
	"./cix.svg": "8040",
	"./clam.svg": "9875",
	"./cloak.svg": "e4a0",
	"./cmm.svg": "a415",
	"./cmt.svg": "59b5",
	"./cnd.svg": "8b68",
	"./cnx.svg": "5ce5",
	"./cny.svg": "315b",
	"./cob.svg": "490a",
	"./colx.svg": "0a02",
	"./comp.svg": "5da9",
	"./coqui.svg": "822d",
	"./cream.svg": "ebcc",
	"./cred.svg": "c7bd",
	"./crpt.svg": "8aa0",
	"./crw.svg": "6a0e",
	"./cs.svg": "db40",
	"./ctr.svg": "2d12",
	"./ctxc.svg": "7557",
	"./curve.svg": "209c",
	"./cvc.svg": "3d70",
	"./cvx.svg": "780d",
	"./d.svg": "da5c",
	"./dai.svg": "ac94",
	"./dash.svg": "d20d",
	"./dat.svg": "311e",
	"./data.svg": "2fc4",
	"./dbc.svg": "860b",
	"./dcn.svg": "e886",
	"./dcr.svg": "780a",
	"./deez.svg": "bff9",
	"./dent.svg": "d421",
	"./dew.svg": "cd0c",
	"./dg.svg": "cbc2",
	"./dgb.svg": "c206",
	"./dgd.svg": "f0a5",
	"./dlt.svg": "db25",
	"./dnt.svg": "252a",
	"./dock.svg": "4b44",
	"./dog.svg": "58ff",
	"./doge.svg": "1254",
	"./dot.svg": "1fba",
	"./dpi.svg": "55ba",
	"./drgn.svg": "dcac",
	"./drop.svg": "5fca",
	"./dta.svg": "2835",
	"./dth.svg": "27f9",
	"./dtr.svg": "c605",
	"./dydx.svg": "dfcb",
	"./ebst.svg": "4f74",
	"./eca.svg": "9bef",
	"./edg.svg": "2b43",
	"./edo.svg": "e96e",
	"./edoge.svg": "1bfb",
	"./egld.svg": "617c",
	"./ela.svg": "4812",
	"./elec.svg": "fe31",
	"./elf.svg": "8c25",
	"./elix.svg": "fa0b",
	"./ella.svg": "6c7e",
	"./emc.svg": "4174",
	"./emc2.svg": "86fd",
	"./eng.svg": "6133",
	"./enj.svg": "950c",
	"./entrp.svg": "d024",
	"./eon.svg": "0800",
	"./eop.svg": "6423",
	"./eos.svg": "c228",
	"./eqli.svg": "3b52",
	"./equa.svg": "11c7",
	"./etc.svg": "fa5f",
	"./eth.svg": "b87a",
	"./ethereum.svg": "2316",
	"./ethos.svg": "7176",
	"./etn.svg": "3c9c",
	"./etp.svg": "2221",
	"./eur.svg": "b956",
	"./evx.svg": "08e6",
	"./exmo.svg": "3814",
	"./exp.svg": "50e4",
	"./fair.svg": "9fb7",
	"./fct.svg": "7a83",
	"./fil.svg": "621b",
	"./fjc.svg": "a828",
	"./fldc.svg": "f5c0",
	"./flo.svg": "724f",
	"./fsn.svg": "c125",
	"./ftc.svg": "aa5e",
	"./ftm.svg": "a721",
	"./ftt.svg": "2942",
	"./fuel.svg": "be87",
	"./fun.svg": "b79c",
	"./game.svg": "e0de",
	"./gas.svg": "b25e",
	"./gbp.svg": "ce87",
	"./gbx.svg": "eaa9",
	"./gbyte.svg": "724e",
	"./generic.svg": "b0e6",
	"./gin.svg": "fa9f",
	"./glxt.svg": "c0d2",
	"./gmr.svg": "f32b",
	"./gno.svg": "c4ed",
	"./gnt.svg": "26e8",
	"./gold.svg": "e920",
	"./grc.svg": "296f",
	"./grin.svg": "24de",
	"./grs.svg": "e4c9",
	"./grt.svg": "74cb",
	"./gsc.svg": "faec",
	"./gto.svg": "02fe",
	"./gup.svg": "7216",
	"./gusd.svg": "da8a",
	"./gvt.svg": "6f44",
	"./gxs.svg": "22a8",
	"./gzr.svg": "0303",
	"./hbar.svg": "c8fd",
	"./hegic.svg": "64e4",
	"./hez.svg": "12cc",
	"./hight.svg": "d389",
	"./hnt.svg": "a275",
	"./hodl.svg": "fd6f",
	"./hot.svg": "e165",
	"./hpb.svg": "af8e",
	"./hsr.svg": "4142",
	"./ht.svg": "3ddb",
	"./html.svg": "899a",
	"./huc.svg": "ef90",
	"./hush.svg": "1c3f",
	"./icn.svg": "9fb3",
	"./icp.svg": "d033",
	"./icx.svg": "f2cc",
	"./ignis.svg": "c1a2",
	"./ilk.svg": "aacb",
	"./image2vector.svg": "fcb3",
	"./inj.svg": "f7bd",
	"./ink.svg": "1942",
	"./ins.svg": "dff1",
	"./ion.svg": "2416",
	"./iop.svg": "bbed",
	"./iost.svg": "f6b8",
	"./iotx.svg": "9cd5",
	"./iq.svg": "97ad",
	"./itc.svg": "e6ec",
	"./jnt.svg": "040e",
	"./jpy.svg": "8477",
	"./kcs.svg": "c3b4",
	"./keep.svg": "0b72",
	"./kin.svg": "e95e",
	"./klown.svg": "6366",
	"./kmd.svg": "8248",
	"./knc.svg": "8168",
	"./kp3r.svg": "fd9a",
	"./krb.svg": "63f4",
	"./ksm.svg": "3f1a",
	"./lbc.svg": "25c7",
	"./lend.svg": "4152",
	"./leo.svg": "b448",
	"./link.svg": "2257",
	"./litecoin.svg": "2717",
	"./lkk.svg": "27ab",
	"./loom.svg": "c562",
	"./lpt.svg": "0a67",
	"./lrc.svg": "be8e",
	"./lsk.svg": "86e8",
	"./ltc.svg": "e4de",
	"./lun.svg": "c517",
	"./luna.svg": "61e7",
	"./maid.svg": "c815",
	"./mana.svg": "d0bb",
	"./matic.svg": "9767",
	"./mcap.svg": "cb90",
	"./mco.svg": "53d0",
	"./mda.svg": "6b30",
	"./mds.svg": "7ae2",
	"./med.svg": "c976",
	"./meetone.svg": "3212",
	"./mft.svg": "656a",
	"./miota.svg": "7787",
	"./mir.svg": "827b",
	"./mith.svg": "46c0",
	"./mkr.svg": "bce5",
	"./mln.svg": "d1f4",
	"./mnx.svg": "78f8",
	"./mnz.svg": "5c96",
	"./moac.svg": "7168",
	"./mod.svg": "e50b",
	"./mona.svg": "4d8a",
	"./msr.svg": "cf78",
	"./mth.svg": "e57c",
	"./mtl.svg": "eb7b",
	"./music.svg": "5e14",
	"./mzc.svg": "8eba",
	"./nano.svg": "c344",
	"./nas.svg": "5379",
	"./nav.svg": "4c42",
	"./ncash.svg": "8e00",
	"./ndz.svg": "0754",
	"./nebl.svg": "eef5",
	"./neo.svg": "4404",
	"./neos.svg": "300c",
	"./neu.svg": "8310",
	"./nexo.svg": "76c8",
	"./nftx.svg": "8314",
	"./ngc.svg": "4dad",
	"./nio.svg": "9141",
	"./nlc2.svg": "275b",
	"./nlg.svg": "cf3a",
	"./nmc.svg": "e550",
	"./nmr.svg": "88cf",
	"./npxs.svg": "2900",
	"./nu.svg": "d691",
	"./nuls.svg": "00b1",
	"./nxs.svg": "5cf1",
	"./nxt.svg": "6b99",
	"./oax.svg": "fa84",
	"./ogn.svg": "7506",
	"./ok.svg": "bdeb",
	"./omg.svg": "682f",
	"./omni.svg": "ed36",
	"./ong.svg": "4631",
	"./ont.svg": "879f",
	"./oot.svg": "08b5",
	"./op.svg": "00c8",
	"./ost.svg": "5286",
	"./ox.svg": "7db1",
	"./oxt.svg": "ab27",
	"./part.svg": "9d8c",
	"./pasc.svg": "266c",
	"./pasl.svg": "d107e",
	"./pax.svg": "9ce0",
	"./pay.svg": "ca1e",
	"./payx.svg": "7aa3",
	"./pink.svg": "ce78",
	"./pirl.svg": "79ca",
	"./pivx.svg": "20ee",
	"./plr.svg": "2790",
	"./poa.svg": "5de5",
	"./poe.svg": "552b",
	"./polis.svg": "bc9f",
	"./poly.svg": "82e4",
	"./pot.svg": "389e",
	"./powr.svg": "e44d",
	"./ppc.svg": "dba9",
	"./ppp.svg": "ad22",
	"./ppt.svg": "c96d",
	"./pre.svg": "5fcc",
	"./prl.svg": "82dd",
	"./pundix.svg": "d5a0",
	"./pungo.svg": "de97",
	"./pura.svg": "5f1a",
	"./qash.svg": "31dd",
	"./qiwi.svg": "561f",
	"./qlc.svg": "91ae",
	"./qrl.svg": "04f3",
	"./qsp.svg": "4e09",
	"./qtum.svg": "42cd",
	"./r.svg": "f935",
	"./rads.svg": "35a4",
	"./rap.svg": "5487",
	"./rcn.svg": "6959",
	"./rdd.svg": "12ef",
	"./rdn.svg": "bfe9",
	"./ren.svg": "553a",
	"./rep.svg": "1433",
	"./repv2.svg": "63dc",
	"./req.svg": "0d7e",
	"./rgt.svg": "3412",
	"./rhoc.svg": "0b0a",
	"./ric.svg": "e516",
	"./rise.svg": "da33",
	"./rlc.svg": "626a",
	"./rpx.svg": "363a",
	"./rsr.svg": "ebae",
	"./rub.svg": "ff19",
	"./rune.svg": "2ecd",
	"./rvn.svg": "47735",
	"./ryo.svg": "f154",
	"./safe.svg": "49b1",
	"./sai.svg": "f716",
	"./salt.svg": "6b7f",
	"./san.svg": "d249",
	"./sbd.svg": "4f5a",
	"./sberbank.svg": "e3b8",
	"./sc.svg": "84f4",
	"./shib.svg": "2c24",
	"./shift.svg": "64aa",
	"./sib.svg": "78cd",
	"./sin.svg": "caa3",
	"./sky.svg": "9207",
	"./slr.svg": "ca39",
	"./sls.svg": "f787",
	"./smart.svg": "ccaf",
	"./sngls.svg": "8c0a",
	"./snm.svg": "85b9",
	"./snt.svg": "f96e",
	"./snx.svg": "559a",
	"./soc.svg": "63a1",
	"./sol.svg": "d54d",
	"./spank.svg": "8fee",
	"./sphtx.svg": "a4b7",
	"./srn.svg": "97d0",
	"./stak.svg": "02b5",
	"./start.svg": "6e7c",
	"./steem.svg": "29f9",
	"./storj.svg": "5c73",
	"./storm.svg": "8979",
	"./stq.svg": "d338",
	"./strat.svg": "9adc",
	"./stx.svg": "b3e1",
	"./sub.svg": "ad0e",
	"./sumo.svg": "4ea4",
	"./sushi.svg": "91c4",
	"./sx.svg": "8e60",
	"./sys.svg": "ba37",
	"./taas.svg": "d32c",
	"./tau.svg": "1529",
	"./tbx.svg": "56bb",
	"./tel.svg": "41b2",
	"./ten.svg": "9da8",
	"./tern.svg": "0496",
	"./tfuel.svg": "2e9f",
	"./tgch.svg": "6066",
	"./theta.svg": "7881",
	"./tix.svg": "f652",
	"./tkn.svg": "9f1d",
	"./tks.svg": "2a68",
	"./tnb.svg": "3330",
	"./tnc.svg": "bfc4",
	"./tnt.svg": "4bf7",
	"./tomo.svg": "b032",
	"./tpay.svg": "742c",
	"./trig.svg": "4b9e",
	"./trtl.svg": "6808",
	"./trx.svg": "93d7",
	"./tusd.svg": "3c86",
	"./tzc.svg": "abc7",
	"./ubq.svg": "17a0",
	"./ubt.svg": "2fe3",
	"./uma.svg": "f2fb",
	"./uni.svg": "f740",
	"./unity.svg": "d3b8",
	"./usc.svg": "afa7",
	"./usd.svg": "620b",
	"./usdc.svg": "dc52",
	"./usdt.svg": "1158",
	"./ust.svg": "315d",
	"./utk.svg": "69de",
	"./veri.svg": "3b08",
	"./vet.svg": "80cf",
	"./vgx.svg": "69a0",
	"./via.svg": "8c99",
	"./vib.svg": "461f",
	"./vibe.svg": "cadf",
	"./vivo.svg": "d971",
	"./vrc.svg": "d68e",
	"./vrsc.svg": "a767",
	"./vtc.svg": "d759",
	"./vtho.svg": "9a4c",
	"./wabi.svg": "8a7b",
	"./wan.svg": "ff09",
	"./waves.svg": "deca",
	"./wax.svg": "eade",
	"./wbtc.svg": "d370",
	"./wgr.svg": "77a9",
	"./wicc.svg": "7487",
	"./wings.svg": "1d1d",
	"./wpr.svg": "180f",
	"./wtc.svg": "1eba",
	"./x.svg": "e26c",
	"./xas.svg": "5e36",
	"./xbc.svg": "a50f",
	"./xbp.svg": "6a88",
	"./xby.svg": "f881",
	"./xcp.svg": "0f13",
	"./xdn.svg": "1eeb",
	"./xem.svg": "5934",
	"./xin.svg": "d0c6",
	"./xlm.svg": "91bb",
	"./xmcc.svg": "8e0a",
	"./xmg.svg": "d140",
	"./xmo.svg": "dd86",
	"./xmr.svg": "b9e8",
	"./xmy.svg": "454d",
	"./xp.svg": "463e",
	"./xpa.svg": "4fa3",
	"./xpm.svg": "8bb5",
	"./xrp.svg": "1de0",
	"./xsg.svg": "957f",
	"./xtz.svg": "ce96",
	"./xuc.svg": "516d",
	"./xvc.svg": "3995",
	"./xvg.svg": "c055",
	"./xzc.svg": "3e57",
	"./yfi.svg": "643c",
	"./yoyow.svg": "5097",
	"./zcl.svg": "f77b",
	"./zec.svg": "ada9",
	"./zel.svg": "8dcd",
	"./zen.svg": "fdb5",
	"./zest.svg": "719d",
	"./zil.svg": "2ec0",
	"./zilla.svg": "ec96",
	"./zrx.svg": "1224"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c646";